(function () {
  var CSS = '\n.rm-pdp-acc{margin-top:22px;border-top:1px solid rgba(0,0,0,.14);}\n.rm-acc{border-bottom:1px solid rgba(0,0,0,.14);}\n.rm-acc__sum{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 2px;font-family:"Cinzel",Georgia,serif;font-weight:700;font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:#1a1a1a;}\n.rm-acc__sum::-webkit-details-marker{display:none;}\n.rm-acc__sum:focus{outline:none;}\n.rm-acc__ic{position:relative;width:14px;height:14px;flex:0 0 auto;}\n.rm-acc__ic:before,.rm-acc__ic:after{content:"";position:absolute;background:#1a1a1a;transition:transform .25s ease,opacity .25s ease;}\n.rm-acc__ic:before{left:0;top:6px;width:14px;height:2px;}\n.rm-acc__ic:after{left:6px;top:0;width:2px;height:14px;}\n.rm-acc[open] .rm-acc__ic:after{transform:scaleY(0);opacity:0;}\n.rm-acc__body{padding:0 2px 18px;font-family:"EB Garamond",Georgia,serif;font-size:16px;line-height:1.65;color:#333;}\n.rm-acc__body p{margin:0 0 6px;}\n.rm-acc__body p:last-child{margin-bottom:0;}\n.rm-mat-list{list-style:none;margin:0;padding:0;}\n.rm-mat-list li{position:relative;padding-left:16px;margin:0 0 9px;line-height:1.5;}\n.rm-mat-list li:last-child{margin-bottom:0;}\n.rm-mat-list li:before{content:"";position:absolute;left:2px;top:10px;width:4px;height:4px;border-radius:50%;background:#1a1a1a;}\n.rm-paytrust{margin:16px 0 4px;text-align:center;}\n.rm-paytrust__secure{display:flex;align-items:center;justify-content:center;gap:7px;font-family:"Cinzel",Georgia,serif;font-weight:700;text-transform:uppercase;letter-spacing:.06em;font-size:13px;color:#1a1a1a;margin-bottom:10px;}\n.rm-paytrust__icons{display:flex;flex-wrap:wrap;justify-content:center;gap:7px;}\n.rm-pay{width:40px;height:24px;display:block;}\n.ast-carousel-card-body{text-align:center !important;}\n.ast-carousel-card-body .ast-addon-title-wrapper{justify-content:center !important;}\n.ast-carousel-card-body .ast-carousel-product-name{display:block !important;width:100%;text-align:center !important;}\n.ast-carousel-card-body .ast-star-rating{display:flex !important;width:100%;justify-content:center !important;margin-top:4px !important;}\n.ast-carousel-card-body .ast-carousel-price-wrapper{justify-content:center !important;}\n.rm-tb{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;border:1px solid rgba(0,0,0,.16);border-radius:10px;padding:20px 8px;margin:16px 0;}\n.rm-tb__i{display:flex;flex-direction:column;align-items:center;text-align:center;gap:11px;padding:0 4px;}\n.rm-tb__ic{height:40px;display:flex;align-items:center;justify-content:center;}\n.rm-tb__ic img{max-height:40px;max-width:46px;width:auto;height:auto;display:block;}\n.rm-tb__t{font-family:"Cinzel",Georgia,serif;font-weight:700;font-size:15px;line-height:1.2;color:#1a1a1a;}\n@media (max-width:480px){.rm-tb__t{font-size:13px;}.rm-tb__ic img{max-height:34px;max-width:40px;}.rm-tb{padding:16px 6px;}}\n';

  var LOCK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>';
  var PAY = '\n<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#fff" stroke="#e4e4e4"></rect><text x="20" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-style="italic" font-size="10" fill="#1a1f71">VISA</text></svg>'
    + '<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#fff" stroke="#e4e4e4"></rect><circle cx="17" cy="12" r="6" fill="#eb001b"></circle><circle cx="24" cy="12" r="6" fill="#f79e1b" fill-opacity=".85"></circle></svg>'
    + '<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#2e77bb"></rect><text x="20" y="15" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="7" fill="#fff">AMEX</text></svg>'
    + '<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#fff" stroke="#e4e4e4"></rect><text x="20" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-style="italic" font-size="9" fill="#003087">Pay<tspan fill="#009cde">Pal</tspan></text></svg>'
    + '<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#5a31f4"></rect><text x="20" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="9" fill="#fff">shop</text></svg>'
    + '<svg class="rm-pay" viewBox="0 0 40 24"><rect width="40" height="24" rx="4" fill="#fff" stroke="#e4e4e4"></rect><text x="20" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="600" font-size="9" fill="#5f6368">G Pay</text></svg>';

  var BADGES = '<div class="rm-tb">'
    + '<div class="rm-tb__i"><span class="rm-tb__ic"><img src="https://cdn.shopify.com/s/files/1/0806/8300/8282/files/Skjermbilde_202024-03-07_20kl._2012.41.46-1709786564922.png?v=1781002376&amp;width=120" alt="" loading="eager"></span><span class="rm-tb__t">Artisan Handmade</span></div>'
    + '<div class="rm-tb__i"><span class="rm-tb__ic"><img src="https://cdn.shopify.com/s/files/1/0806/8300/8282/files/81307_3545f78f-5eb5-415e-9cc4-96d6170dddcf.png?v=1781002376&amp;width=120" alt="" loading="eager"></span><span class="rm-tb__t">Premium Materials</span></div>'
    + '<div class="rm-tb__i"><span class="rm-tb__ic"><img src="https://cdn.shopify.com/s/files/1/0806/8300/8282/files/pngimg.com_20-_20symbol_infinity_PNG11-1709787158240.png?v=1781002377&amp;width=120" alt="" loading="eager"></span><span class="rm-tb__t">Lifelong Quality</span></div>'
    + '<div class="rm-tb__i"><span class="rm-tb__ic"><img src="https://cdn.shopify.com/s/files/1/0806/8300/8282/files/694073.png?v=1781002376&amp;width=120" alt="" loading="eager"></span><span class="rm-tb__t">Water &amp; Sweatproof</span></div>'
    + '</div>';

  function injectCSS() {
    if (document.getElementById('rm-pdp-acc-css')) return;
    var s = document.createElement('style');
    s.id = 'rm-pdp-acc-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function isBulletP(el) {
    if (el.tagName !== 'P') return false;
    var t = el.textContent || '';
    if (t.indexOf('•') > -1) return true;
    var segs = el.innerHTML.split(/<br\s*\/?>/i);
    var dash = 0;
    for (var i = 0; i < segs.length; i++) {
      var tx = segs[i].replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
      if (/^[-–•]\s*\S/.test(tx)) dash++;
    }
    return dash >= 2;
  }

  function extractItems(el) {
    var segs = el.innerHTML.split(/<br\s*\/?>/i);
    var items = [];
    for (var i = 0; i < segs.length; i++) {
      var tx = segs[i].replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/•/g, '').replace(/^[\s\-–]+/, '').trim();
      if (!tx) continue;
      if (/^materials\s*:?\s*$/i.test(tx)) continue;
      items.push(tx);
    }
    return items;
  }

  function makeAcc(title, contentEl, open) {
    var d = document.createElement('details');
    d.className = 'rm-acc';
    if (open) d.setAttribute('open', '');
    var s = document.createElement('summary');
    s.className = 'rm-acc__sum';
    s.innerHTML = '<span>' + title + '</span><span class="rm-acc__ic"></span>';
    var body = document.createElement('div');
    body.className = 'rm-acc__body';
    body.appendChild(contentEl);
    d.appendChild(s);
    d.appendChild(body);
    return d;
  }

  function buildTrust() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('.rm-paytrust')) return;
    var atc = document.querySelector('.product-form button[name=add], .add-to-cart, button[name=add]');
    if (!atc) return;
    var block = atc.closest('.product-block') || atc.closest('form');
    if (!block || !block.parentNode) return;
    var row = document.createElement('div');
    row.className = 'rm-paytrust';
    row.innerHTML = '<div class="rm-paytrust__secure">' + LOCK + '<span>Guaranteed safe &amp; secure checkout</span></div><div class="rm-paytrust__icons">' + PAY + '</div>';
    block.parentNode.insertBefore(row, block.nextSibling);
  }

  function buildBadges() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('.rm-tb')) return;
    var atc = document.querySelector('.product-form button[name=add], .add-to-cart, button[name=add]');
    if (!atc) return;
    var block = atc.closest('.product-block') || atc.closest('form');
    if (!block || !block.parentNode) return;
    var div = document.createElement('div');
    div.innerHTML = BADGES;
    var node = div.firstChild;
    var pay = document.querySelector('.rm-paytrust');
    if (pay && pay.parentNode) { pay.parentNode.insertBefore(node, pay.nextSibling); }
    else { block.parentNode.insertBefore(node, block.nextSibling); }
  }

  function moveLifestyle() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var life = document.querySelector('[id*="lifestyle_slider"]');
    if (!life) return;
    var secs = document.querySelectorAll('.ast-carousel-section');
    var target = null;
    for (var i = 0; i < secs.length; i++) {
      var h = secs[i].querySelector('.ast-carousel-title');
      if (h && /recently viewed/i.test(h.textContent)) target = secs[i];
    }
    if (!target) return;
    if (target.nextElementSibling === life) return;
    target.parentNode.insertBefore(life, target.nextElementSibling);
  }

  function build() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var rte = document.querySelector('.product-block .rte');
    if (!rte || rte.getAttribute('data-rm-acc') === '1') return;

    var titleEl = document.querySelector('.product-single__title, .product__title, h1.h1');
    var prodTitle = titleEl ? norm(titleEl.textContent) : '';

    var kids = [].slice.call(rte.children);
    var materialNodes = [], sizing = [], remove = [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (el.tagName === 'H1' || el.tagName === 'H2' || el.tagName === 'H3') { remove.push(el); continue; }
      if (prodTitle && norm(t) === prodTitle) { remove.push(el); continue; }
      if (/^materials\s*:?\s*$/i.test(t)) { remove.push(el); continue; }
      if (/handmade[\s\S]*last a lifetime/i.test(t) && t.length < 90) { remove.push(el); continue; }
      if (/^(length|sizing|size)\b/i.test(t) && t.length < 70) { sizing.push(el); continue; }
      if (isBulletP(el)) { materialNodes.push(el); continue; }
    }

    var items = [];
    for (var n = 0; n < materialNodes.length; n++) { items = items.concat(extractItems(materialNodes[n])); }
    for (var r = 0; r < remove.length; r++) { if (remove[r].parentNode) remove[r].parentNode.removeChild(remove[r]); }
    for (var mn = 0; mn < materialNodes.length; mn++) { if (materialNodes[mn].parentNode) materialNodes[mn].parentNode.removeChild(materialNodes[mn]); }

    if (items.length || sizing.length) {
      var wrap = document.createElement('div');
      wrap.className = 'rm-pdp-acc';
      if (items.length) {
        var ul = document.createElement('ul');
        ul.className = 'rm-mat-list';
        for (var it = 0; it < items.length; it++) { var li = document.createElement('li'); li.textContent = items[it]; ul.appendChild(li); }
        wrap.appendChild(makeAcc('Materials', ul, false));
      }
      var sizeWrap = document.createElement('div');
      if (sizing.length) { for (var z = 0; z < sizing.length; z++) sizeWrap.appendChild(sizing[z]); }
      else { var p = document.createElement('p'); p.textContent = 'Adjustable sizing for a comfortable fit. Each piece is handmade to last a lifetime.'; sizeWrap.appendChild(p); }
      wrap.appendChild(makeAcc('Sizing', sizeWrap, false));
      rte.parentNode.insertBefore(wrap, rte.nextSibling);
    }

    rte.setAttribute('data-rm-acc', '1');
  }

  function init() { injectCSS(); build(); buildTrust(); buildBadges(); moveLifestyle(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  setInterval(init, 1500);
})();
